import type { ArchiveFile, ComponentProps, FormsReviewViewerCustomProps } from './types'

interface Props extends ComponentProps {
	signedUrl?: string | null | undefined
	archiveFiles?: ArchiveFile[]
	showUnavailableHint?: boolean
}

export const FormsReviewViewer = ({ component, signedUrl, archiveFiles, showUnavailableHint = true }: Props) => {
	const { linkText } = component.custom as FormsReviewViewerCustomProps

	if (archiveFiles && archiveFiles.length > 0) {
		return (
			<div className='flex flex-col gap-1'>
				{archiveFiles.map((file) => (
					<a
						key={file.fileName}
						href={file.signedUrl}
						target='_blank'
						rel='noopener noreferrer'
						className='inline-block text-primary-600 cursor-pointer hover:text-primary-800 hover:underline text-base'>
						{file.fileName}
					</a>
				))}
			</div>
		)
	}

	if (signedUrl) {
		return (
			<a
				href={signedUrl}
				download
				className='inline-block text-primary-600 cursor-pointer hover:text-primary-800 hover:underline text-base'>
				{linkText}
			</a>
		)
	}

	return (
		<span className='text-neutral-400 text-base'>
			{linkText}
			{showUnavailableHint ? ' (PDF not available)' : ''}
		</span>
	)
}
